import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import Clipboard from '@react-native-clipboard/clipboard';
import React from 'react';
import { Text, View } from 'react-native';
import CopyIcon from '@/assets/icon/ic_copy.svg';
import { useMe } from '@/atoms/Auth';
import { SccTouchableHighlight } from '@/components/SccTouchableHighlight';
import { color } from '@/constant/color';
import ToastUtils from '@/utils/ToastUtils';
export default function IdRow() {
    var _a;
    const { userInfo } = useMe();
    const displayId = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.displayId) !== null && _a !== void 0 ? _a : userInfo === null || userInfo === void 0 ? void 0 : userInfo.id;
    function copyIdToClipboard() {
        if (displayId) {
            Clipboard.setString(displayId);
            ToastUtils.show('ID가 복사되었습니다');
        }
    }
    return (_jsxs(View, { className: "px-5 py-5", children: [_jsx(Text, { className: "mb-[8px] font-pretendard-regular text-[14px] leading-[20px] text-gray-50", children: "ID" }), _jsxs(View, { className: "flex-row items-center justify-between", children: [_jsx(Text, { className: "font-pretendard-medium text-[16px] leading-[26px] text-black", children: displayId }), _jsx(SccTouchableHighlight, { elementName: "setting_copy_id_button", activeOpacity: 0.7, underlayColor: color.brand10, className: "flex-row items-center gap-[2px] p-[4px]", onPress: copyIdToClipboard, children: _jsxs(View, { className: "flex-row items-center gap-[2px]", children: [_jsx(CopyIcon, { width: 16, height: 16, color: color.brandColor }), _jsx(Text, { className: "font-pretendard-medium text-[13px] leading-[18px] text-brand-50", children: "\uBCF5\uC0AC" })] }) })] })] }));
}
